import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Checkbox, Segmented, Tooltip } from 'antd';
import { OD_MAP_TYPES } from '../../../../constants/odMap';
import { includes } from '../../../../utils/array';
import { useOdMapConfig } from '../../../../hooks/SimViewer/useOdMapConfig';
import { useDataFilter } from '../../../../hooks/SimViewer/useDataFilter';
import { InfoPopoverButton } from '../../../InfoPopoverButton';

const OdMapConfig = (): ReactNode => {
  const { t } = useTranslation();
  const { dataFilter } = useDataFilter();
  const { odMapType, setOdMapType, showsAllOd, setShowsAllOd } =
    useOdMapConfig();

  return (
    <>
      <StyledSegmented
        options={[
          {
            value: OD_MAP_TYPES.MESH_125M,
            label: (
              <Tooltip title={`125m ${t('mesh')}`}>
                <span>125m</span>
              </Tooltip>
            ),
            disabled: dataFilter.pass.wayIds.length > 0,
          },
          {
            value: OD_MAP_TYPES.MESH_1KM,
            label: (
              <Tooltip title={`1km ${t('mesh')}`}>
                <span>1km</span>
              </Tooltip>
            ),
            disabled: false,
          },
          {
            value: OD_MAP_TYPES.CITY,
            label: (
              <Tooltip title={t('aggregationTypes.areas')}>
                <span>{t('areas.city')}</span>
              </Tooltip>
            ),
            className: 'antd-segmented-item-grow',
            disabled: false,
          },
          {
            value: OD_MAP_TYPES.TOWN,
            label: (
              <Tooltip title={t('aggregationTypes.areas')}>
                <span>{t('areas.town')}</span>
              </Tooltip>
            ),
            className: 'antd-segmented-item-grow',
            disabled: false,
          },
        ]}
        value={odMapType}
        onChange={(value: string | number): void => {
          if (includes(Object.values(OD_MAP_TYPES), value)) {
            setOdMapType(value);
          }
        }}
      />
      <StyledCheckbox
        checked={showsAllOd}
        onChange={(event: { target: { checked: boolean } }): void => {
          setShowsAllOd(event.target.checked);
        }}
      >
        {t('showAllTrips')}
        <InfoPopoverButton
          content={t('additionalInfos.odMapCutoff', { returnObjects: true })}
        />
      </StyledCheckbox>
    </>
  );
};

const StyledSegmented = styled(Segmented)`
  .ant-segmented-item:not(.antd-segmented-item-grow) {
    flex: 0 1 48px;
  }
  .ant-segmented-item.antd-segmented-item-grow {
    flex: 1 1 0px;
  }
  .ant-segmented-item-label {
    padding: 0 2px;
  }
`;

const StyledCheckbox = styled(Checkbox)`
  margin-left: auto;

  .ant-checkbox + span {
    padding: 0;
    margin-left: 4px;
  }
`;

export { OdMapConfig };
